
































import traceQuery from '~/queries/trace.gql'

export default

	props:
		traceData: Object

	data: ->
		loaded: false
		sectionData: {}
		config:
			slidesPerPage: 1
			showDots: false
			showArrows: true

	fetch: ->
		@sectionData = await @$craft.getEntry
			query: traceQuery
			variables:
				section: 'trace'
				type: 'certifications'
				slug: 'certifications'

		@loaded = true

	computed:
		cards: -> @sectionData.certifications.map (card) ->
			title: card.text
			copy: card.simpleWysiwyg
			href: ''
			image: card.image
			includeFor: card.includeFor

		filteredCards: -> @cards.filter (card) =>
			card.includeFor.includes @productType

		block: -> {
			layout: 'small'
			desktopColumns: '3'
			cards: @filteredCards
		}

		productType: ->
			desc = @traceData?.ItemDesc
			if desc.includes 'Global Mild'
				return 'globalMild'
			else if desc.includes 'Global Medium'
				return 'globalMedium'
			else if desc.includes 'Global Robust'
				return 'globalRobust'
			else if desc.includes 'COR Rstd Garlic EVOO Chef'
				return 'garlicSqueeze'
			else if desc.includes 'COR Rstd Garlic EVOO Blend'
				return 'garlicGlass'
			else if desc.includes 'COR Jalapeno Herb EVOO'
				return 'jalapeno'
			else if desc.includes 'COR Black Truffle EVOO'
				return 'truffle'
			else return '100California'

